import { environment } from './environment';

/**
 * Fails loudly at app boot if the environment file still has placeholder values.
 * Without this, MSAL throws a cryptic "endpoints_resolution_error" that's hard to debug.
 */
export function assertEnvironmentConfigured(): void {
  const issues: string[] = [];
  const m = environment.msal;

  if (m.clientId.includes('REPLACE_')) issues.push('msal.clientId');
  if (m.authority.includes('REPLACE_')) issues.push('msal.authority');
  if (m.apiScopes.some(s => s.includes('REPLACE_'))) issues.push('msal.apiScopes');
  if (environment.apiBaseUrl.includes('REPLACE_')) issues.push('apiBaseUrl');

  if (issues.length === 0) return;

  const msg =
    `Command Center is not configured. The following placeholders need real values in ` +
    `src/environments/environment.ts: ${issues.join(', ')}. ` +
    `See README.md > "Local setup" for the Entra app registration steps.`;

  // Surface visibly: a top-of-page banner plus a thrown error so MSAL never starts with garbage.
  if (typeof document !== 'undefined') {
    const banner = document.createElement('div');
    banner.style.cssText =
      'position:fixed;top:0;left:0;right:0;z-index:99999;background:#b91c1c;color:white;' +
      'padding:1rem;font-family:system-ui;font-size:14px;line-height:1.4;';
    banner.textContent = msg;
    document.body?.prepend(banner);
  }
  throw new Error(msg);
}
